"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@material-ui/icons");
var Button_1 = __importDefault(require("../Button"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        label: {
            marginLeft: theme.spacing(1),
            fontWeight: 'bold',
        },
    });
});
var PomodoroButton = function (_a) {
    var mode = _a.mode, time = _a.time, other = __rest(_a, ["mode", "time"]);
    var classes = useStyles();
    var _b = __read(react_1.useState(document.title), 1), originalTitle = _b[0];
    var minutes = Math.floor(time / 60);
    var seconds = time % 60;
    var secondsString = seconds < 10 ? "0" + seconds : seconds;
    react_1.useEffect(function () {
        if (mode !== 'inactive') {
            document.title = minutes + ":" + secondsString + " " + originalTitle;
        }
    }, [minutes, originalTitle, mode, secondsString]);
    return (react_1.default.createElement(Button_1.default, __assign({ variant: "outlined", className: classes.root }, other),
        mode === 'inactive' && react_1.default.createElement(icons_1.AvTimerRounded, null),
        mode !== 'inactive' && minutes + ":" + secondsString,
        react_1.default.createElement("span", { className: classes.label },
            mode === 'inactive' && 'Timer',
            mode === 'focus' && 'Focus',
            mode === 'break' && 'Break')));
};
exports.default = PomodoroButton;
//# sourceMappingURL=PomodoroButton.js.map